/**
 * Converts a HWM format (YYYYMMDD0000000000) to a date
 * @param hwm - HWM string in format YYYYMMDD0000000000
 * @returns Date object
 */
export function convertHwmToDate(hwm: string): Date {
  // Convert HWM format (YYYYMMDD0000000000) to date
  // biome-ignore lint/correctness/useParseIntRadix: Bulk suppression as part of biome migration
  const year = parseInt(hwm.substring(0, 4))
  // biome-ignore lint/correctness/useParseIntRadix: Bulk suppression as part of biome migration
  const month = parseInt(hwm.substring(4, 6)) - 1 // JavaScript months are 0-indexed
  // biome-ignore lint/correctness/useParseIntRadix: Bulk suppression as part of biome migration
  const day = parseInt(hwm.substring(6, 8))
  return new Date(year, month, day)
}
